<div class="container" id="spinerLoader" *ngIf="loader">
    <div class="loader">Loading...</div>
</div>

<div mat-dialog-title class="modal-header header-radius-4">
    <div class="mx-3 d-flex justify-content-between align-items-center">
        <div>
            <h4>Messages</h4>
        </div>
        <div>
            <button type="button" class="close close-btn" title="Close" mat-dialog-close>
                <i class="fa fa-close"></i>
            </button>
        </div>
    </div>
</div>

<mat-dialog-content>
    <div class="p-0 mx-4 mb-4">
        <div class="row">
            <app-chat-list [sRListGroupList]="sRListGroupList" [accessingFrom]="'dialog'"
                [internalMemberList]="internalMemberList"></app-chat-list>
            <app-message-panel [internalMemberList]="internalMemberList"></app-message-panel>
        </div>
    </div>
</mat-dialog-content>